import React, { useEffect, useMemo } from "react"

import Input from "@mui/material/Input"
import { debounce } from "lodash"

import { useTranslations } from "@cirrus/core/i18n"
import { MuiIcon } from "@cirrus/ui-kit"

import { getSearchValue, setSearchValue } from "../../helpers"
import { useTableContext } from "../../provider"

export const SearchField = () => {
  const ctx = useTableContext()
  const { i18n } = useTranslations()
  const { searchDisabled, searchPlaceholder } = ctx.props
  const { setValue } = ctx.search.api

  const setValueHandler = (value: string) => {
    setValue(value)
    setSearchValue(value)
  }

  const search = useMemo(() => (
      !searchDisabled
        ? debounce(setValueHandler, 300)
        : debounce(() => {}, 300)
    ),
    [searchDisabled])

  useEffect(() => {
    return () => search && search.cancel()
  }, [])

  // TODO: Move outside the component
  if (searchDisabled) return null

  return (
    <Input
      sx={{
        width: "15rem",
        fontSize: "1.2rem",
        lineHeight: "1.6rem",
        paddingBottom: ".3rem"
      }}
      placeholder={searchPlaceholder || i18n("General:Search")}
      startAdornment={<MuiIcon.Search sx={{
        fontSize: "2.4rem",
        marginRight: ".8rem",
        color: "rgba(0, 0, 0, 0.54)"
      }} />}
      onChange={(event) => {
        search(event.target.value)
      }}
      onClick={(event) => {
        event.stopPropagation()
      }}
      defaultValue={getSearchValue()}
    />
  )
}
